<div class="button-container">
<button class="audio-button" (click)="onClickAudioButton()" [attr.aria-describedby]="recordingError ? 'voice-input-error' : null"
  [ngClass]="{'active' : isRecording || isPausedForTTS, 'fixed': appState.agent.currentConversation().length > 0}">
  <div class="button-content">
    <div class="left-content">
      
      <div class="icon" *ngIf="!isPausedForTTS && !isProcessingSpeech && !isRecording && !appState.agent.isAgentSpeaking()">
        <app-svg-loader url="assets/svg/mic-solid.svg" height="24px"></app-svg-loader>
      </div>

      <div class="ai-bubble" *ngIf="(isPausedForTTS && !isProcessingSpeech) || appState.agent.isAgentSpeaking()">
        <app-ai-blob [isAnimated]="isPausedForTTS || appState.agent.isAgentSpeaking()"></app-ai-blob>
      </div>

      <div class="ai-bubble" *ngIf="isRecording && !isProcessingSpeech && !isPausedForTTS">
        <app-ai-blob [audioStream]="mediaStream" [isAnimated]="isRecording" isUser="true"></app-ai-blob>
      </div>

      <div class="icon" *ngIf="isProcessingSpeech">
        <app-typing-dots></app-typing-dots>
      </div>

      <div class="button-text">
        <span style="padding-left: 4px;" *ngIf="isRecording && !isPausedForTTS && !isProcessingSpeech">Listening</span>
        <span *ngIf="!isRecording && !isPausedForTTS && !isProcessingSpeech && !appState.agent.isAgentSpeaking()">Push to Talk</span>
        <span *ngIf="isProcessingSpeech">{{dynamicStatusText}}</span>
        <span style="padding-left: 4px;" *ngIf="isPausedForTTS || appState.agent.isAgentSpeaking()">Agent Speaking...</span>
  
      </div>

    </div>

  </div>
</button>
<p *ngIf="recordingError" id="voice-input-error" class="voice-input-error" role="alert">{{ recordingError }}</p>
</div>
